export const fixedEnvironment = {
  sessionCookieName: 'Junglegymcms_REFRESH_SESSION',
  accessTokenHeader: 'Junglegymcms_ACCESS_SESSION',
  gqlEntryPoint: '/graphql/graphql',
  jsonModalWidthLarge: '80%',
};
